import { useNavigate, useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { Button } from "@mui/material";

import { useEffect } from "react";
import { useDispatch } from "react-redux";

const pageList = [
  "/application/personalinfo",
  "/application/trustedindividual",
  "/application/dependantdetails",
  "/application/objectives",
  "/application/incomeandexpenses",
  "/application/assetsandliabilities",
  "/application/currentplans",
  "/application/riskinvestment",
  "/application/riskcka",
  "/application/needsanalysis",
  "/application/affordability",
  "/application/summary",
  "/application/products/insurance",
  "/application/products/investment",
];

const pageMap = new Map();
pageMap.set("/application/personalinfo", 0);
pageMap.set("/application/trustedindividual", 1);
pageMap.set("/application/dependantdetails", 2);
pageMap.set("/application/objectives", 3);
pageMap.set("/application/incomeandexpenses", 4);
pageMap.set("/application/assetsandliabilities", 5);
pageMap.set("/application/currentplans", 6);
pageMap.set("/application/riskinvestment", 7);
pageMap.set("/application/riskcka", 8);
pageMap.set("/application/needsanalysis", 9);
pageMap.set("/application/affordability", 10);
pageMap.set("/application/summary", 11);
pageMap.set("/application/products/insurance", 12);
pageMap.set("/application/products/investment", 13);

let location = "";
let navigate = "";

export function onPrev() {
  console.log("PageNavigator | onPrev");

  const currentIndex = pageMap.get(location.pathname);

  /*
      When current page's index lesser than total pages
      check if there's there's a next page. If there is, load it.

      When current page index == pages.size. That means current page is already on the last page.
      Don't navigate further.
    */
  if (currentIndex > 0) {
    //Get URL of previous page.
    navigate(pageList[currentIndex - 1]);
    //navigate(1);
  }
}

export function onNext() {
  console.log("PageNavigator | onNext");

  let currentIndex = pageMap.get(location.pathname);
  const highestIndexPerPageCycle = pageMap.size - 1; //Eg. !4 pages --> 13 as highest cycle index

  /*
    When current page's index lesser than total pages
    check if there's there's a next page. If there is, load it.

    When current page index == pages.size. That means current page is already on the last page.
    Don't navigate further.
  */

  let applicantCount = 1;
  //   let applicantCount = 2;

  //Get URL of next page.
  if (currentIndex < pageMap.size - 1) {
    navigate(pageList[currentIndex + 1]);
  }

  //   if (currentIndex < pageMap.size * applicantCount - 1) {
  //     //MOVE PAGE: When current Index is under the  1cycle (Eg. Index: 0- 13)
  //     if (currentIndex < pageMap.size - 1) {
  //       navigate(pageList[currentIndex + 1]);
  //     } else {
  //       currentIndex = currentIndex % highestIndexPerPageCycle;
  //       navigate(pageList[(currentIndex % highestIndexPerPageCycle) + 1]);
  //     }

  //     //MOVE PAGE: When current Index is above 1st cycle (Eg. Index: 14 - 27)
  //   }
}

export default function PageNavigator({ validateForm, isValid }) {
  location = useLocation();
  navigate = useNavigate();

  const dispatch = useDispatch();

  function reset_application() {
    const action = {
      type: "RESET_APPLICATION",
      payload: "",
    };

    dispatch(action);
  }

  return (
    <>
      <Grid spacing={2} size={12}>
        <Paper elevation={0} sx={{ minHeight: "50px", pt: 1 }}>
          <Stack spacing={2} direction="row" justifyContent="center">
            <Button
              variant="contained"
              sx={{ width: "100px" }}
              disabled={false}
              onClick={onPrev}
            >
              Previous
            </Button>

            <Button
              type="submit"
              variant="contained"
              sx={{ width: "100px" }}
              disabled={isValid ? false : true}
              onClick={validateForm}
            >
              Next
            </Button>

            <Button
              variant="contained"
              sx={{ width: "100px" }}
              onClick={reset_application}
            >
              RESET
            </Button>
          </Stack>
        </Paper>
      </Grid>
    </>
  );
}
